export default __webpack_public_path__ + "static/media/new_logo_course.bcfe1f3c.svg";